<mat-toolbar class="header">
	<button mat-icon-button (click)="onToggleSidebar()" class="menu-button">
		<mat-icon>menu</mat-icon>
	</button>

	<div class="logo-container">
		<img src="logo.png" alt="Zanga African Metrics" class="logo" />
	</div>

	<span class="spacer"></span>

	<nav class="nav-items">
		<a
			mat-button
			routerLink="/cohorts"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			(click)="navigateTo('/cohorts'); $event.preventDefault()"
		>
			<mat-icon>assessment</mat-icon>
			Surveys
		</a>
	</nav>

	<button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu">
		<div class="user-avatar">
			<img
				*ngIf="(user$ | async)?.photo_url"
				[src]="(user$ | async)?.photo_url"
				alt="Profile photo"
				(error)="onImageError($event)"
			/>
			<mat-icon *ngIf="!(user$ | async)?.photo_url">account_circle</mat-icon>
		</div>
	</button>

	<mat-menu #userMenu="matMenu" class="user-menu-panel">
		<div class="user-info" *ngIf="user$ | async as user">
			<p class="email">{{ user.email }}</p>
		</div>
		<a mat-menu-item routerLink="/profile" (click)="navigateTo('/profile'); $event.preventDefault()">
			<mat-icon>person</mat-icon>
			<span>Profile</span>
		</a>
		<mat-divider></mat-divider>
		<button mat-menu-item (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>Logout</span>
		</button>
	</mat-menu>
</mat-toolbar>
